import { render, staticRenderFns } from "./ItemForJournalWizard.vue?vue&type=template&id=14bb573a&"
import script from "./ItemForJournalWizard.vue?vue&type=script&lang=js&"
export * from "./ItemForJournalWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports